import { Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import StreamDetail from './pages/StreamDetail';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Redeem from './pages/Redeem';
import Watch from './pages/Watch';

function App() {
  return (
    <div className="app">
      <header className="header">
        <div className="container header-content">
          <Link to="/" className="logo">
            <img src="/logo.png" alt="Creative Conduit" className="logo-image" />
            CreativeConduit.Live
          </Link>
        </div>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stream/:id" element={<StreamDetail />} />
          <Route path="/checkout/:streamId" element={<Checkout />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/redeem" element={<Redeem />} />
          <Route path="/watch/:streamId" element={<Watch />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
